/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ViewConfigurationRequest {
    getFixupPrototypeFunction() { return ViewConfigurationRequest.fixupPrototype; }

    static newInstance(model: Partial<ViewConfigurationRequest>): ViewConfigurationRequest {
        let obj = Object.assign(new ViewConfigurationRequest(), model);
        ViewConfigurationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ViewConfigurationRequest>): ViewConfigurationRequest {
        if (!model) return null;
        return ViewConfigurationRequest.newInstance(<ViewConfigurationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ViewConfigurationRequest) {
        if (!obj) return;

        models.ViewConfigurationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ViewConfigurationRequest): boolean {
        Object.setPrototypeOf(obj, ViewConfigurationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Template URI
     */
    template_uri: string;

}
